import {
  createAsyncThunk,
  createSlice, PayloadAction,
} from '@reduxjs/toolkit';
import { isEqual } from 'lodash';
import { IFiltersSliceState } from '../../DrilldownDashboardContainer/filters/filtersSlice';
import { RootState } from '../store';
import {buildHTMLFiltersSubtitle} from '../utils';
import { getCommentTrend } from './commentTrendAPI';

export interface ICommentTrendAPIResponse {
  series: ISeries[];
  categories: [];
  segmentCategory: string;
  segmentName: string;
  title: string;
  rows: [];
  question: string;
  avidLabel: string;
  surveyLabel: string;
  commentType: string;
}

interface ICommentTrendState {
  isLoading: boolean;
  apiResponse: ICommentTrendAPIResponse;
  chartSubtitle: string
  dataPoints: ISeries[]
}
interface ISeries {
  marker?: ISeriesMarker;
  name: string
  data: number[]
  color: string
}

interface ISeriesMarker {
  symbol: string
}

const initialState: ICommentTrendState = {
  isLoading: false,
  apiResponse: {
    series: [],
    categories: [],
    segmentCategory: '',
    segmentName: '',
    title: '',
    rows: [],
    question: '',
    avidLabel: '',
    surveyLabel: '',
    commentType: '',
  },
  chartSubtitle: '',
  dataPoints: [],
};

export const loadCommentTrend = createAsyncThunk(
  'commentTrend/get',
  async (filters: IFiltersSliceState) => {
    return getCommentTrend(filters);
  }
);

export const commentTrendSlice = createSlice({
  name: 'commentTrend',
  initialState,
  reducers: {
    setHTMLSubtitle: (state: ICommentTrendState, action) => {
      const apiResponse = action.payload;
      if (!isEqual(state, apiResponse)) {
        state.apiResponse = apiResponse;
      }
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadCommentTrend.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      loadCommentTrend.fulfilled,
      (state, action: PayloadAction<ICommentTrendAPIResponse>) => {
        const apiResponse = action.payload;
        if (apiResponse) {
          state.apiResponse = apiResponse;
          const {avidLabel, surveyLabel, segmentCategory, question, commentType} = apiResponse;
          state.chartSubtitle = buildHTMLFiltersSubtitle(
            avidLabel,
            surveyLabel,
            '',
            '',
            segmentCategory,
            question,
            commentType
          )
          const chartMarkerSymbols = ['circle', 'diamond', 'square'];
          state.dataPoints = apiResponse.series.map((seriesItem, idx) => {
            return {
              name: seriesItem.name,
              data: seriesItem.data,
              color: seriesItem.color,
              marker: {
                symbol: chartMarkerSymbols[idx]
              },
            }
          })
          state.isLoading = false;
        }
      }
    );
  },
});

export const selectCommentTrend = (state: RootState) => state.commentTrend;
export default commentTrendSlice.reducer;
